module.exports = __webpack_public_path__ + "img/project.675e88dd.jpg";